// A flat's recurring charges (maintenance/water/security/trash), read the
// same way the server's monthly bill run does: the newer schedule fields
// (flatMaintenanceAmount, flatWaterAmount, flatSecurityAmount,
// flatTrashAmount) with a fallback to the pre-schedule legacy columns
// (flatMaintananceCharges, flatSecurityCharges, flatTrashCharges — there is
// no legacy water column) for properties registered before the
// monthly/annual option existed.
//
// The current property form only ever writes the new fields, so reading the
// legacy columns directly (as most display screens did) showed these
// charges as missing for every property created since.
const CHARGE_FIELDS = {
  maintenance: { amountField: "flatMaintenanceAmount", legacyField: "flatMaintananceCharges" },
  water: { amountField: "flatWaterAmount", legacyField: "flatWaterCharges" },
  security: { amountField: "flatSecurityAmount", legacyField: "flatSecurityCharges" },
  trash: { amountField: "flatTrashAmount", legacyField: "flatTrashCharges" },
};

/** { maintenance, water, security, trash } amounts for a flat. */
export const getChargeAmounts = (flat = {}) => {
  const amounts = {};
  for (const [key, { amountField, legacyField }] of Object.entries(CHARGE_FIELDS)) {
    amounts[key] = Number(flat?.[amountField]) || Number(flat?.[legacyField]) || 0;
  }
  return amounts;
};
